module.exports = __webpack_public_path__ + "static/media/loading.1912c52e.gif";